import React from "react";
import _ from "lodash";
import Select from "react-select";

import { NetworkAPI } from "apis";

class YieldSetsMultiSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      options: [],
      selectedValue: null,
      defaultValue: null,
      isLoading: false,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    const queryParams = {
      networkId: this.props.networkId,
    };
    const items = await NetworkAPI.getYieldSets(queryParams);

    if (this.props.handleOnLoadData) this.props.handleOnLoadData(items);

    let options = _.map(items, (r) => {
      return {
        value: r.yieldSetId,
        label: r.yieldSetId + " - " + r.name,
      };
    });

    let defaultItem;
    if (this.props.defaultValue) {
      defaultItem = _.filter(options, (o) => {
        return this.props.defaultValue.includes(o.value);
      });
    }

    this.setState(
      {
        items,
        options,
        selectedValue: defaultItem,
        isLoading: false,
      },
      () => {
        if (defaultItem) {
          this.handleChange(defaultItem);
        } else {
          if (this.props.handleNoData) this.props.handleNoData();
        }
      }
    );
  }

  async componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.defaultValue, this.props.defaultValue)) {
      if (this.props.selectedYieldSet === null) {
        this.setState({
          selectedValue: null,
        });
      } else {
        const newList = _.filter(this.props.selectedYieldSet, (d) => {
          return !_.find(this.state.items, { yieldSetId: d.yieldSetId });
        });
        if (newList.length > 0) {
          const newOptions = _.map(newList, (r) => {
            return {
              value: r.yieldSetId,
              label: r.yieldSetId + " - " + r.name,
            };
          });
          this.setState((prevState) => ({
            selectedValue: [...prevState.selectedValue, ...newOptions],
            options: [...prevState.options, ...newOptions],
          }));
        }
      }
    }

    if (prevProps.networkId !== this.props.networkId) {
      this.setState({ isLoading: true });
      const queryParams = {
        networkId: this.props.networkId,
      };
      const items = await NetworkAPI.getYieldSets(queryParams);

      let options = _.map(items, (r) => {
        return {
          value: r.yieldSetId,
          label: r.yieldSetId + " - " + r.name,
        };
      });

      this.setState({
        items,
        options,
        isLoading: false,
      });
    }
  }

  handleChange(option) {
    this.setState({
      selectedValue: option,
    });

    const list = _.filter(this.state.items, (item) => {
      return _.find(option, (o) => {
        return o.value === item.yieldSetId;
      });
    });
    this.props.handleOnChange(list);
  }

  render() {
    const { options, selectedValue, isLoading } = this.state;
    return (
      <>
        <Select
          defaultValue={selectedValue}
          value={selectedValue}
          onChange={this.handleChange}
          options={options}
          isMulti={true}
          isClearable={true}
          isLoading={isLoading}
        />
      </>
    );
  }
}

export default YieldSetsMultiSelector;
